const settings = {}
settings.siteUrl = window.SiteSettings.siteUrl;
settings.siteName = window.SiteSettings.siteName;
settings.siteNameCaps = window.SiteSettings.siteNameCaps;
settings.socialLinks = window.SiteSettings.socialLinks;
settings.logoUrl = window.SiteSettings.logoUrl;
settings.siteImageFolder = '/assets/' + settings.siteName + '/img/';
settings.vueReCaptchaSiteKey = window.SiteSettings.vueReCaptchaSiteKey;
settings.googleTagId = window.SiteSettings.googleTagId;
settings.aboutUs = window.SiteSettings.aboutUs;
settings.showBlog = window.SiteSettings.showBlog;
settings.blogTitle = window.SiteSettings.blogTitle;
settings.isShabbat = window.SiteSettings.isShabbat;
settings.shabbatEnds = window.SiteSettings.shabbatEnds;
settings.contactPhone = window.SiteSettings.contactPhone;
settings.contactEmail = window.SiteSettings.contactEmail;
settings.homepageBanner = window.SiteSettings.homepageBanner;
settings.topBannerAnimationSrc = window.SiteSettings.topBannerAnimationSrc;
settings.facebookPixelId = window.SiteSettings.facebookPixelId;
settings.logoImageNoBackground = window.SiteSettings.logoImageNoBackground;
settings.jcn_pid = window.SiteSettings.jcn_pid;
settings.jcn_ads_on = window.SiteSettings.jcn_ads_on;
settings.medianet_on = window.SiteSettings.medianet_on;
settings.purimMode = window.SiteSettings.purimMode;
settings.baseDomain = window.SiteSettings.baseDomain;


export default settings